export const PAGE = {
  GAME: 'game',
  RESULTS: 'results',
  TOURNAMENT: 'tournament',
  LOADING: '',
  SELECT_RULES: 'select-rules',
  CHOOSE_LEADERBOARDS: 'choose-leaderboards',
};

// RULE - To avoid clashing with clinch ids, no 6 letter pages
